export default __webpack_public_path__ + "static/media/srfb2.4c24800e.jpeg";